module.exports = __webpack_public_path__ + "img/frequently.5baa1515.svg";